import React, { useEffect, useState } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { Location } from 'history';
import useCreateSingleReport from 'Hooks/query-hooks/reports/useCreateSingleReport';
import { SaveReportErrorModal } from '../SaveReport/SaveReportErrorModal';
import { ReportNotSavedWarningModal } from './ReportNotSavedWarningModal';

type Props = {
    extendedFormValues: ProcessedNewMerchantReportFormValues | undefined;
    saveBtnClicked: boolean;
    reportType: ReportType;
};

const ReportNotSavedWarning = ({ extendedFormValues, saveBtnClicked, reportType }: Props) => {
    const history = useHistory();
    const newReport = useCreateSingleReport({ type: reportType, extendedFormValues });
    const { isSuccess, isError } = newReport;
    const [reportNotSavedIsOpen, setReportNotSavedIsOpen] = useState(false);
    const [saveErrorIsOpen, setSaveErrorIsOpen] = useState(false);
    const [lastLocation, setLastLocation] = useState<Location | null>(null);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);

    const handleBlockNavigation = (nextLocation: Location): boolean => {
        if (!confirmedNavigation) {
            setReportNotSavedIsOpen(true);
            setLastLocation(nextLocation);
            return false;
        }
        return true;
    };

    const handleContinueNavigation = () => {
        setReportNotSavedIsOpen(false);
        setConfirmedNavigation(true);
    };

    useEffect(() => {
        if (confirmedNavigation && lastLocation && !saveBtnClicked) {
            history.push(`/reports?reportType=${reportType}`);
        }
    }, [confirmedNavigation, history, lastLocation, saveBtnClicked, reportType]);

    return (
        <>
            <Prompt when={!!extendedFormValues} message={handleBlockNavigation} />
            <ReportNotSavedWarningModal
                isOpen={reportNotSavedIsOpen}
                onClose={() => setReportNotSavedIsOpen(false)}
                onContinueWithNavigation={handleContinueNavigation}
                onSaveReport={() => newReport.mutate('')}
                saveError={isError}
                saveSuccess={isSuccess}
                setSaveErrorIsOpen={setSaveErrorIsOpen}
                reportType={reportType}
            />
            <SaveReportErrorModal
                isOpen={saveErrorIsOpen}
                closeModal={() => {
                    newReport.reset();
                    setSaveErrorIsOpen(false);
                }}
                createReport={() => newReport.mutate('')}
            />
        </>
    );
};

export default ReportNotSavedWarning;
